import type { Dispatch, SetStateAction } from "react";

import { Trash2 } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal";

interface DeleteFileModalProps {
  fileName?: string;
  isDeleting?: boolean;
  isOpen: boolean;
  onDelete: () => void;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
}

export function DeleteFileModal({
  fileName,
  isDeleting = false,
  isOpen,
  onDelete,
  onOpenChange,
}: DeleteFileModalProps) {
  const title = "Delete File";
  const text = fileName
    ? `Are you sure you want to delete "${fileName}"? This action cannot be undone.`
    : "Are you sure you want to delete this file? This action cannot be undone.";

  return (
    <ConfirmationModal
      confirmButtonColor="destructive"
      confirmButtonText="Delete"
      icon={<Trash2 className="text-featured-icon-light-fg-error" />}
      isConfirmLoading={isDeleting}
      isOpen={isOpen}
      onConfirm={onDelete}
      onOpenChange={onOpenChange}
      text={text}
      title={title}
    />
  );
}
